import { HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { v4 as uuidv4 } from 'uuid';

export function requestTrackerInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  if (req.url.includes('viacep.com.br')) {
    return next(req);
  }

  const requestId = uuidv4();

  return next(req.clone({
    setHeaders: {
      'x-correlation-id': requestId
    }
  }));
}
